
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Glycosylated_hemoglobin_target",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Glycosylated_hemoglobin_target.vue